<template>
  <div class="problem">
    <Tabs :value="state" @on-click="handleChangeTab">
      <TabPane label="全部" name="all"
        ><ProblemTab v-if="state == 'all'" :state="state" />
      </TabPane>
      <TabPane label="未回复" name="0"
        ><ProblemTab v-if="state == '0'" :state="state" />
      </TabPane>
      <TabPane label="待评价" name="1"
        ><ProblemTab v-if="state == '1'" :state="state" />
      </TabPane>
      <TabPane label="已评价" name="2"
        ><ProblemTab v-if="state == '2'" :state="state" />
      </TabPane>
      <div class="addProblem" slot="extra">
        <span @click="handleAdd">
          <img src="../../assets/img/addProblem.png" alt="" />添加问题
        </span>
      </div>
    </Tabs>
  </div>
</template>

<script>
import ProblemTab from "@/components/userCenter/ProblemTab.vue";
export default {
  name: "problem",
  components: { ProblemTab },
  data() {
    return {
      state: "all",
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    handleAdd() {
      this.$router.push({
        path: "/attendanceProcess/addProblem",
      });
    },

    handleChangeTab(key) {
      this.state = key;
    },
  },
};
</script>
<style lang="scss" scoped>
.problem {
  margin-bottom: 25px;
  width: 962px;
  float: right;
  background: #fff;
  .addProblem {
    line-height: 59px;
    padding-right: 20px;
    span {
      display: inline-block;
      cursor: pointer;
      color: rgba(49, 175, 88, 1);
      line-height: 20px;
      img {
        vertical-align: middle;
        margin-right: 6px;
      }
    }
  }
}
</style>
